var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-main",class:{ 'disable-scroll': _vm.disableScroll }},[_c('div',{staticClass:"content"},[_c('i-header'),_c('router-view',{staticClass:"page"}),_c('i-popup')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }